"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _ImageTag = _interopRequireDefault(require("../ImageTag"));
var _Dialog = _interopRequireDefault(require("material-ui/Dialog"));
var _cloudinaryReact = require("cloudinary-react");
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
require("./AssetContainer.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); } //import PDFViewer from "../PDFViewer"; // temporarily removing to get build working
/**
* AssetContainer
some parts are only needed for cms editing, the cms may also need to pass more info in the props than destination would
<div class="image-text-container" (conditional:isEditMode)>
  <div class="outer-container" (conditional:isEditMode)>
    <div class="(image|video|audio)-container">
      <img> | <video> | <audio>
      <div class="asset-text" (conditional:showCaption)/>
*/
var AssetText = function AssetText(props) {
  if (props.show && props.metaConfig) {
    var storyLayoutConfig = props.storyLayoutConfig;
    var _props$metaConfig = props.metaConfig,
      title = _props$metaConfig.title,
      caption = _props$metaConfig.caption,
      secondaryCaption = _props$metaConfig.secondaryCaption,
      credit = _props$metaConfig.credit;
    var showAssetTitle = storyLayoutConfig ? storyLayoutConfig.hasOwnProperty("showAssetTitle") ? storyLayoutConfig.showAssetTitle : true : true;
    var showAssetCaption = storyLayoutConfig ? storyLayoutConfig.hasOwnProperty("showAssetCaption") ? storyLayoutConfig.showAssetCaption : true : true;
    var showAssetCredit = storyLayoutConfig ? storyLayoutConfig.hasOwnProperty("showAssetCredit") ? storyLayoutConfig.showAssetCredit : true : true;
    return /*#__PURE__*/_react["default"].createElement("figcaption", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "caption-container"
    }, showAssetTitle && title ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "caption-title",
      dangerouslySetInnerHTML: {
        __html: title
      }
    }) : null, showAssetCaption && caption ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "caption primary",
      dangerouslySetInnerHTML: {
        __html: caption
      }
    }) : null, secondaryCaption ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "caption secondary",
      dangerouslySetInnerHTML: {
        __html: secondaryCaption
      }
    }) : null, showAssetCredit && credit ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "credit",
      dangerouslySetInnerHTML: {
        __html: credit
      }
    }) : null));
  } else {
    return null;
  }
};
var AssetContainer = /*#__PURE__*/function (_Component) {
  _inherits(AssetContainer, _Component);
  var _super = _createSuper(AssetContainer);
  function AssetContainer(props) {
    var _this;
    _classCallCheck(this, AssetContainer);
    _this = _super.call(this, props);
    _this.state = {
      openModal: false
    };
    _this.processEditClick = _this.processEditClick.bind(_assertThisInitialized(_this));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.openModal = _this.openModal.bind(_assertThisInitialized(_this));
    return _this;
  }

  // right now the modal is only used for assets that are videos....
  _createClass(AssetContainer, [{
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        openModal: false
      });
    }
  }, {
    key: "openModal",
    value: function openModal(elementID) {
      this.setState({
        openModal: true
      });
    }

    // Functions used by Editing Mode
  }, {
    key: "processEditClick",
    value: function processEditClick(value, event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof this.props.triggerEditFunc !== "undefined" && this.props.isEditMode) {
        this.props.triggerEditFunc(value);
      }
    }
  }, {
    key: "assetIsSet",
    value: function assetIsSet() {
      return typeof this.props !== "undefined" && (typeof this.props.cloudPublicId !== "undefined" || typeof this.props.src !== "undefined");
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        layout = _this$props.layout,
        storyLayoutConfig = _this$props.storyLayoutConfig,
        className = _this$props.className,
        assetID = _this$props.assetID,
        assetType = _this$props.assetType,
        use = _this$props.use,
        cloudName = _this$props.cloudName,
        cloudPublicId = _this$props.cloudPublicId,
        assetConfig = _this$props.assetConfig,
        location = _this$props.location,
        metaConfig = _this$props.metaConfig,
        styles = _this$props.styles,
        showAssetText = _this$props.showAssetText,
        isLightboxIconVisible = _this$props.isLightboxIconVisible,
        isDetailAvailable = _this$props.isDetailAvailable,
        assetFit = _this$props.assetFit,
        focalPoint = _this$props.focalPoint,
        margin = _this$props.margin,
        padding = _this$props.padding,
        background = _this$props.background,
        frame = _this$props.frame,
        shadow = _this$props.shadow,
        filter = _this$props.filter,
        buildInAnimation = _this$props.buildInAnimation,
        buildInAnimationDelay = _this$props.buildInAnimationDelay,
        buildInAnimationSpeed = _this$props.buildInAnimationSpeed,
        animatedEffect = _this$props.animatedEffect,
        animatedEffectSpeed = _this$props.animatedEffectSpeed,
        isLoopAnimatedEffect = _this$props.isLoopAnimatedEffect,
        isCaptionVisible = _this$props.isCaptionVisible,
        captionPosition = _this$props.captionPosition,
        controls = _this$props.controls,
        autoPlay = _this$props.autoPlay,
        loop = _this$props.loop,
        playAsModal = _this$props.playAsModal,
        poster = _this$props.poster,
        isEditMode = _this$props.isEditMode,
        elementID = _this$props.elementID,
        isActiveEditingElement = _this$props.isActiveEditingElement,
        assetSelectorFunc = _this$props.assetSelectorFunc,
        assets = _this$props.assets,
        src = _this$props.src,
        posterSrc = _this$props.posterSrc;
      var _this$state = this.state,
        assetW = _this$state.assetW,
        asswtH = _this$state.asswtH;

      // NOTE we need the abiilty if we are in edit mode to
      // 1. add a special onClick function
      // 2. allow the different types

      var content;
      // this value targets the assetConfig and pulls out any styles that shoudl over write for this use
      var assetStyleOverride = styles;

      // Custom classes that will be added to the Asset Container if they're defined
      var customClasses = metaConfig && metaConfig.classes ? metaConfig.classes : "";
      customClasses += assetFit ? " ".concat(assetFit) : "";
      customClasses += focalPoint ? " ".concat(focalPoint) : "";
      customClasses += margin ? " ".concat(margin) : "";
      customClasses += padding ? " ".concat(padding) : "";
      customClasses += background ? " ".concat(background) : "";
      customClasses += frame ? " ".concat(frame) : "";
      customClasses += shadow ? " ".concat(shadow) : "";
      customClasses += filter ? " ".concat(filter) : "";
      customClasses += buildInAnimation ? " animate ".concat(buildInAnimation, " ").concat(buildInAnimationSpeed, " ").concat(buildInAnimationDelay, " ").concat(animatedEffect, " ").concat(animatedEffectSpeed, " ").concat(isLoopAnimatedEffect ? "animate-effect-loop" : "") : "";
      customClasses += isCaptionVisible ? captionPosition ? " ".concat(captionPosition) : "" : "";
      var showTextClass = showAssetText ? "with-text" : "";
      var lightboxIconClass = isLightboxIconVisible ? "lightbox-icon" : isDetailAvailable ? "lightbox-icon" : "";
      var extension = /(?:\.([^.]+))?$/;
      var useCloudinary = src ? false : true;
      var clickFunc = isEditMode ? function (event) {
        event.preventDefault();
        event.stopPropagation();
        _this2.assetIsSet() ? _this2.processEditClick(elementID, event) : assetSelectorFunc(elementID);
      } : null;
      var editClass = isEditMode ? "edit-mode ".concat(layout, " ").concat(isActiveEditingElement ? "active-editing" : "", " ").concat(this.assetIsSet() ? "" : "no-image") : "";

      // nothing to write out if the data isnt there
      // just as a catch if not editing AND no asset is present
      if (!cloudPublicId && !src && !isEditMode) {
        return null;
      }

      // if we are Editing and there is nothing add the placeholder
      if (!this.assetIsSet() && isEditMode) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(use !== "background" ? "sc-module asset" : "asset", " ").concat(customClasses)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "sc-edit sc-edit-module empty-selector ".concat(editClass, " ").concat(className),
          onClick: clickFunc
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "click-to-edit-container"
        }, /*#__PURE__*/_react["default"].createElement("h3", null, "Click to Edit"))));
      }

      // destination/preview use
      switch (assetType) {
        case "video":
        case "cloudinaryVideo":
          // NOTE we dont' need the view modal IF EDITING
          // first pull from the props, however the modal is always autoplay
          var vidProps = {
            controls: controls,
            autoPlay: autoPlay,
            loop: loop,
            poster: poster
          };
          var vidType = "mp4"; // this can later be read from project data and passed down
          // be sure backgronds ARE never played as modal
          if ((playAsModal || (0, _isUndefined2["default"])(playAsModal) || isEditMode) && use !== "background") {
            // MODAL PLAYBACK VIDEO
            vidProps = {
              autoPlay: autoPlay,
              loop: loop
            }; //don't have controlls on modal

            // the posterframe will be a special url
            // NOTE may want to use the cld core method to build url
            var _imgSrc = useCloudinary ? "".concat(location && location.protocol ? location.protocol : "", "//res.cloudinary.com/").concat(cloudName, "/video/upload").concat(assetConfig && assetConfig.posterFrame ? "/so_" + parseFloat(assetConfig.posterFrame, 2) : "", "/").concat(cloudPublicId, ".jpg") : posterSrc;
            // NOTE could we leverage the ImageTag even with posters?
            // TODO: look into passing ref back up like i did in the other context
            // testing using the video tag  but we can't if its offline
            // NOTE: to try and avoid 0x0 pixel issue, we leverage the Cld Video component for the pdf poster, like a video, since the Cld Image component doesnt allow you to pass a url, which is needed here
            content = /*#__PURE__*/_react["default"].createElement("div", {
              className: "".concat(className, " video-poster-frame-container ").concat(showTextClass),
              onClick: isEditMode ? clickFunc : this.openModal
            }, /*#__PURE__*/_react["default"].createElement(_ImageTag["default"], {
              assetConfig: assetConfig,
              src: _imgSrc,
              format: "jpg",
              type: "video",
              cloudName: cloudName,
              startOffset: assetConfig && assetConfig.posterFrame ? parseFloat(assetConfig.posterFrame, 2) : "",
              cloudPublicId: cloudPublicId,
              className: "img-wrapper",
              layout: layout
            }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
              icon: "play",
              className: "play"
            }), /*#__PURE__*/_react["default"].createElement(AssetText, {
              show: showAssetText,
              metaConfig: metaConfig,
              storyLayoutConfig: storyLayoutConfig
            })), isEditMode ? null : /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
              className: "asset-modal ".concat(layout),
              modal: true,
              open: this.state && this.state.openModal,
              onRequestClose: this.closeModal,
              autoScrollBodyContent: false,
              paperClassName: "modal-paper",
              overlayClassName: "modal-overlay",
              bodyClassName: "modal-body",
              contentClassName: "modal-content",
              title: /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("div", {
                className: "modal-close",
                onClick: this.closeModal
              }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
                icon: "close"
              })))
            }, /*#__PURE__*/_react["default"].createElement("section", {
              className: "video-content"
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: "".concat(className, " video-container col")
            }, useCloudinary ? /*#__PURE__*/_react["default"].createElement(_cloudinaryReact.Video, _extends({
              style: assetStyleOverride,
              cloudName: cloudName,
              publicId: cloudPublicId
            }, vidProps, {
              autoPlay: true
            })) : /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
              autoPlay: true,
              style: assetStyleOverride
            }), /*#__PURE__*/_react["default"].createElement("source", {
              src: src,
              type: "video/".concat(vidType)
            }))))));
          } else {
            // INLINE PLAYBACK VIDEO
            content = /*#__PURE__*/_react["default"].createElement("div", {
              className: "".concat(editClass, " ").concat(className, " video-container ").concat(showTextClass),
              onClick: clickFunc
            }, useCloudinary ? /*#__PURE__*/_react["default"].createElement(_cloudinaryReact.Video, _extends({
              cloudName: cloudName,
              publicId: cloudPublicId
            }, vidProps, {
              style: assetStyleOverride
            })) : /*#__PURE__*/_react["default"].createElement("video", _extends({}, vidProps, {
              style: assetStyleOverride
            }), /*#__PURE__*/_react["default"].createElement("source", {
              src: src,
              type: "video/".concat(vidType)
            })), /*#__PURE__*/_react["default"].createElement(AssetText, {
              show: showAssetText,
              metaConfig: metaConfig,
              storyLayoutConfig: storyLayoutConfig
            }));
          }
          break;
        case "pdf":
          var iframeSrc = useCloudinary ? "".concat(location && location.protocol ? location.protocol : "", "//res.cloudinary.com/").concat(cloudName, "/image/upload/").concat(cloudPublicId) : src;
          var imgSrc = useCloudinary ? "".concat(location && location.protocol ? location.protocol : "", "//res.cloudinary.com/").concat(cloudName, "/image/upload/f_auto,q_auto,c_fill,pg_1/v1/").concat(cloudPublicId, ".jpg") : posterSrc; //NOTE: need to be sure cloudPublicId has no extension
          // NOTE: to try and avoid 0x0 pixel issue, we leverage the Cld Video component for the pdf poster, like a video, since the Cld Image component doesnt allow you to pass a url, which is needed here
          content = /*#__PURE__*/_react["default"].createElement("div", {
            className: "".concat(className, " pdf-poster-frame-container ").concat(showTextClass, " ").concat(editClass),
            onClick: isEditMode ? clickFunc : this.openModal
          }, /*#__PURE__*/_react["default"].createElement(_ImageTag["default"], {
            src: imgSrc,
            className: "img-wrapper",
            isPoster: true,
            cloudPublicId: cloudPublicId
          }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            icon: "touch",
            className: "play play-touch"
          }), /*#__PURE__*/_react["default"].createElement(AssetText, {
            show: showAssetText,
            metaConfig: metaConfig,
            storyLayoutConfig: storyLayoutConfig
          })), isEditMode ? null : /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
            className: "asset-modal ".concat(layout),
            modal: true,
            open: this.state && this.state.openModal,
            onRequestClose: this.closeModal,
            autoScrollBodyContent: false,
            paperClassName: "modal-paper",
            overlayClassName: "modal-overlay",
            bodyClassName: "modal-body",
            contentClassName: "modal-content",
            title: /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("div", {
              className: "modal-close",
              onClick: this.closeModal
            }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
              icon: "close"
            })))
          }, /*#__PURE__*/_react["default"].createElement("section", {
            className: "pdf-content"
          })));
          break;
        case "audio":
          // TODO:
          content = /*#__PURE__*/_react["default"].createElement("div", {
            className: "".concat(editClass, " ").concat(className, " audio-container ").concat(showTextClass),
            onClick: clickFunc
          }, /*#__PURE__*/_react["default"].createElement("audio", null), /*#__PURE__*/_react["default"].createElement(AssetText, {
            show: showAssetText,
            metaConfig: metaConfig,
            storyLayoutConfig: storyLayoutConfig
          }));
          break;
        default:
          // NOTE: this compoenent accounts for non cloudinary images...
          // and tranfrmations creation
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "".concat(use !== "background" ? "sc-module asset" : "asset", " ").concat(customClasses)
          }, /*#__PURE__*/_react["default"].createElement(_ImageTag["default"], _extends({}, this.props, {
            className: "".concat(editClass, " ").concat(className, " image-container ").concat(showTextClass, " ").concat(lightboxIconClass),
            imageStyle: assetStyleOverride,
            onClick: clickFunc
          }), /*#__PURE__*/_react["default"].createElement(AssetText, {
            show: showAssetText,
            metaConfig: metaConfig,
            storyLayoutConfig: storyLayoutConfig
          })), use !== "background" && /*#__PURE__*/_react["default"].createElement("div", {
            className: "sc-edit sc-edit-module",
            onClick: clickFunc
          }));
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(use !== "background" ? "sc-module asset" : "asset", " ").concat(customClasses)
      }, content);
    }
  }]);
  return AssetContainer;
}(_react.Component);
var _default = AssetContainer;
exports["default"] = _default;